

export function createCookie(name,value,days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime()+(days*24*60*60*1000));
    var expires = "; expires="+date.toGMTString();
  }
  else var expires = "";
  document.cookie = name+"="+value+expires+"; path=/";
}

export function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

//
// // Parse the URL
// function getParameterByName(name) {
//   name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
//   var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
//     results = regex.exec(location.search);
//   return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
// }
//
//
// export default function createCookies() {
//
//   // Give the URL parameters variable names
//   var source = getParameterByName('utm_source');
//   var medium = getParameterByName('utm_medium');
//   var campaign = getParameterByName('utm_campaign');
//
//   if(source){
//     createCookie('utm_source',source,90);
//   }
//   if(medium){
//     createCookie('utm_medium',medium,90);
//   }
//   if(campaign){
//     createCookie('utm_campaign',campaign,90);
//   }
//
//
// }





// WEBPACK FOOTER //
// ./src/libs/cookies.js